import { ChevronDown, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

// Pill-shaped variant picker for bundle rows (PDP 3.4). Sold-out options stay
// selectable so the shopper can see stock, but the row's Add button disables.
export const VariantPill = ({ variants, value, onChange, testId }) => {
  const current = variants.find((v) => v.label === value) || variants[0];
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="inline-flex items-center gap-1.5 rounded-full border border-riversol-blue text-riversol-blue bg-white px-3.5 py-1.5 text-[12px] font-medium tracking-[0.02em] whitespace-nowrap hover:bg-riversol-blue/5 transition-colors data-[state=open]:bg-riversol-blue/5"
        >
          <span>
            {current.label}
            {current.soldOut && <span className="font-normal text-neutral-500"> — Sold out</span>}
          </span>
          <ChevronDown size={14} strokeWidth={2} className="transition-transform data-[state=open]:rotate-180" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={6} className="min-w-[180px] rounded-md border-neutral-200 p-1 shadow-lg">
        {variants.map((v) => {
          const selected = v.label === current.label;
          return (
            <DropdownMenuItem
              key={v.label}
              onSelect={() => onChange(v.label)}
              data-testid={`${testId}-option-${v.label.replace(/\s+/g, "-").toLowerCase()}`}
              className={`flex items-center justify-between gap-4 rounded-sm px-3 py-2 text-[12.5px] cursor-pointer ${
                selected ? "bg-neutral-100 text-neutral-900" : "text-neutral-700"
              } ${v.soldOut ? "text-neutral-400" : ""}`}
            >
              <span>
                {v.label}
                {v.soldOut && <span className="text-neutral-400"> — Sold out</span>}
              </span>
              {selected && <Check size={13} strokeWidth={2.5} className="text-riversol-blue" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default VariantPill;
